export function cleanStorage() {
  sessionStorage.removeItem("@token");
  sessionStorage.removeItem("Usuario");
}
